module.exports = __webpack_public_path__ + "img/undertakingCases10.a50b11bf.jpg";